$.Event('contentAdded');
$.Event('contentRemoved');
$.Event('contentAnimated');
$.Event('stateChanged');
$.Event('polygonChanged');

window.Navigation = {
    session: Math.random().toString(36).substr(2, 9),
    currentIndex: 0,
    stack: [],
    init: function () {
        let cover = $('#cover-images picture');
        let state = {
            searchTerm: Application.searchInput.val(),
            url: window.location.href.replace(/^(?:\/\/|[^\/]+)*\//, '/'),
            index: 0,
            cluster: $('#map').data('cluster') || 1,
            marker: $('#map').data('marker'),
            markers: $('#map').data('markers'),
            home: !$('#content').hasClass('not-home'),
            title: $('#content').hasClass('not-home') ? $('body').data('title') : false,
            back: $('#content').hasClass('not-home') ? $('body').data('back') : false,
            session: Navigation.session
        };
        window.history.replaceState(state, state.url);
        state.content = $('main .navigation-wrapper');
        if (state.content.data('photo')) state.photo_id = parseInt(state.content.data('photo'), 10);
        if (state.content.data('keyword')) state.keyword_id = parseInt(state.content.data('keyword'), 10);
        if (state.content.data('heritage')) state.heritage_id = parseInt(state.content.data('heritage'), 10);
        if (state.content.data('tour')) state.tour = state.content.data('tour');
        if (state.content.data('tour-index')) state.tour_index = state.content.data('tour-index');
        if (cover.length > 0) state.cover = cover;
        Navigation.stack.push(state);

        $(window).on('popstate', Navigation.onPopState);
        $(document).on('contentAdded', Navigation.initContent).trigger('contentAdded', $('main'));
    },
    current: function () {
        return Navigation.stack[Navigation.currentIndex];
    },
    push: function(state) {
        const current = Navigation.current();
        if (state.noBack && current.content) {
            state.noBack = (current.content.find('a[href="' + state.url + '"]').length === 0);
        }
        state.url = state.url.replace(/^(?:\/\/|[^\/]+)*\//, '/');
        state.session = Navigation.session;
        if (state.url === current.url && !Navigation.isLoading) return;
        let fromHome = current.home;
        state.index = Navigation.currentIndex + 1;
        if (!state.home && current.searchTerm && !state.searchTerm && current.searchTerm.length > 0) {
            state.searchTerm = current.searchTerm;
        }
        if (state.polygon === undefined) {
            state.polygon = current.polygon;
        }
        if (WeleerMap.initialized && !state.cluster && !MarkerCluster.activeCluster) {
            state.cluster = 1;
        }
        let historyState = Object.assign({}, state);
        if (historyState.content) delete historyState.content;
        window.history.pushState(historyState, (state.title ? state.title : state.searchTerm) , state.url);
        Navigation.fadeOutCurrent(state.index < Navigation.currentIndex);

        let removedStates = Navigation.stack.splice(state.index);
        for (let removedState of removedStates) {
            if (removedState.content) $(document).trigger('contentRemoved', removedState.content);
        }

        Navigation.stack.push(state);
        Navigation.currentIndex = state.index;
        Navigation.update();

        Navigation.getStateContent(state, function() {
            if (!state.home && !fromHome && !state.noBack) {
                let backContainer = state.content.find('.back-container');
                if (backContainer.length === 0) backContainer = $('<div class="back-container"/>').prependTo(state.content);
                state.backButton = $('<div class="back-button"/>').appendTo(backContainer);
                let title = Navigation.stack[state.index - 1].back || Navigation.stack[state.index - 1].title;
                if (!title || title.length === 0) title = 'Terug';
                state.backButton.html(title).on('click', Navigation.onClickBack);
            }
            if ((!state.cluster || state.cluster === 1) && !state.markers && !state.home) {
                if (current.markers && (!state.marker || $.inArray(state.marker, current.markers) > -1)) {
                    state.markers = current.markers;
                } else if (state.optional_cluster) state.cluster = state.optional_cluster;
            }
            if (!state.tour && WeleerMap.activeTour) state.tour = WeleerMap.activeTour;
            if (!state.tour_index && WeleerMap.activeTourIndex) state.tour_index = WeleerMap.activeTourIndex;
            Navigation.fadeInCurrent();
        });
    },
    search: function (query) {
        Navigation.fadeOutCurrent();
        $.ajax({
            url: '/search',
            type: 'POST',
            data: { token: $.csrfToken, q: query },
            dataType: 'json',
            success: Navigation.searchComplete.bind(Navigation, query),
            error: Navigation.searchComplete.bind(Navigation, query)
        });
    },
    searchComplete: function (query, response) {
        if (response && response.url) {
            Navigation.push({
                url: response.url,
                searchTerm: response.search,
                title: response.title
            });
        } else {
            let noResults = $('<div class="navigation-wrapper no-results out right"/>');
            $('<h1>Geen resultaten</h1>').appendTo(noResults);
            $('<p>Er werden helaas geen foto\'s gevonden voor uw zoekopdracht. Pas de parameters aan en probeer opnieuw.</p>').appendTo(noResults);
            Navigation.push({
                url: Navigation.current().url,
                searchTerm: query,
                polygon: false,
                content: noResults
            });
            $(document).trigger('contentAdded', noResults);
        }
    },
    goHome: function(event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        Navigation.push({
            url: $('#logo').attr('href').replace(/^(?:\/\/|[^\/]+)*\//, '/'),
            searchTerm: '',
            home: true,
            polygon: false
        });
    },
    goBackToHome: function(event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        WeleerMap.setTour(null);
        Navigation.setTourWaypoint(0);
        const index = Navigation.getLastHomeIndex();
        if (index < 0) {
            Navigation.goHome();
        } else if (index === Navigation.currentIndex) {
            if (Navigation.isLoading) {
                Navigation.fadeInCurrent(true);
            }
        } else {
            window.history.go(index - Navigation.currentIndex);
        }
    },
    goToIndex: function(index) {
        const backwards = index < Navigation.currentIndex;
        Navigation.fadeOutCurrent(backwards);
        Navigation.currentIndex = index;
        Navigation.update();
        Navigation.getStateContent(Navigation.current(), function() {
            Navigation.fadeInCurrent(backwards);
        });
    },
    goBack: function(amount) {
        amount = Math.min(Math.max(1, amount || 1), Navigation.currentIndex);
        window.history.go(-amount);
    },
    getLastHomeIndex: function() {
        for (var i = Navigation.currentIndex; i >= 0; i--) {
            if (Navigation.stack[i].home) return i;
        }
        return -1;
    },
    getStateContent: function(state, callback) {
        if (state.content) {
            state.content.appendTo('main');
            if (callback) callback(state);
        } else {
            let ajaxUID = new Date().valueOf() + Math.random();
            Navigation.ajaxUID = ajaxUID;
            state.content = $('<div class="navigation-wrapper in right"/>');
            $.getJSON(state.url, function(data) {
                state.content.html(data.content);
                if (Navigation.ajaxUID === ajaxUID) state.content.appendTo('main');
                if (data.photo_id) state.photo_id = parseInt(data.photo_id, 10);
                if (data.keyword_id) state.keyword_id = parseInt(data.keyword_id, 10);
                if (data.heritage_id) state.heritage_id = parseInt(data.heritage_id, 10);
                if (data.cluster) state.cluster = data.cluster;
                if (data.optional_cluster) state.optional_cluster = data.optional_cluster;
                if (data.markers) state.markers = data.markers;
                if (data.cover) state.cover = $(data.cover);
                if (data.polygon !== undefined) state.polygon = Navigation.parsePolygon(data.polygon);
                if (data.title) state.title = data.title;
                if (data.back) state.back = data.back;
                if (data.tour) state.tour = data.tour;
                if (data.tour_index) state.tour_index = data.tour_index;
                $(document).trigger('contentAdded', state.content);
                if (callback) callback(state);
            });
        }
    },
    fadeInCurrent: function(backwards) {
        Navigation.isLoading = false;
        if (Navigation.loaderTimer) clearTimeout(Navigation.loaderTimer);
        let current = Navigation.current();
        if (current.outTimer) clearTimeout(current.outTimer);
        if (current.inTimer) clearTimeout(current.inTimer);
        $('#content').removeClass('loading').toggleClass('with-cover', !!current.cover);
        $(document).trigger('stateChanged', current);
        current.content.removeClass('left right');
        current.content.appendTo('main');
        if (current.cover) current.cover.appendTo($('#cover-images')).removeClass('out').addClass('in');
        current.content.removeClass('out').addClass('in ' + (backwards ? 'left' : 'right'));
        setTimeout(function(){
            current.content.addClass('animated');
            current.content.removeClass('in out left right');
        }, 20);
        if (current.home) {
            $('#content').removeClass('not-home');
            $('#header').css('max-height', $('#header-content').height());
        }
        let title = current.title || current.searchTerm || '';
        let siteName = $('meta[property="og:site_name"]').attr('content');
        document.title = title ? title.decodeHTML() + ' - ' + siteName : siteName;
        $('body').attr('data-title', title || siteName);
        if (WeleerMap.initialized) {
            WeleerMap.selectMarker(current.marker);
            WeleerMap.selectMarkers(current.markers);
            WeleerMap.selectCluster(current.cluster);
        }
        WeleerMap.setTour(current.tour);
        Navigation.setTourWaypoint(current.tour_index);
        current.inTimer = setTimeout(function(){
            $(document).trigger('contentAnimated');
            if (current.home) $('#header').css('max-height', '');
        }, 250);
        $(document).trigger('polygonChanged', current.polygon);
    },
    fadeOutCurrent: function(backwards) {
        let current = Navigation.current();
        if (current.content && current.content.hasClass('out')) return;
        if (!backwards) {
            $(window).scrollToTop($(window).width() < 1000 && !$('#content').hasClass('touring') ? $('main').offset().top : 0);
        }
        Navigation.isLoading = true;
        if (WeleerMap.initialized && Marker.activeMarker) Marker.activeMarker.deactivate();
        if (current.outTimer) clearTimeout(current.outTimer);
        if (current.inTimer) clearTimeout(current.inTimer);
        if (current.cover) current.cover.removeClass('in').addClass('out');
        if (current.home) {
            if (!$('#content').hasClass('not-home')) {
                $('#content').removeClass('home-animated');
                $('#header').css('max-height', $('#header-content').height());
                setTimeout(function(){
                    $('#content').addClass('not-home home-animated');
                }, 10);
            }
        }
        current.content.removeClass('left right');
        current.content.removeClass('in').addClass('animated out ' + (backwards ? 'right' : 'left'));
        current.outTimer = setTimeout(function(){
            current.content.removeClass('in out left right animated');
            current.content.remove();
            if (current.cover) current.cover.remove();
        }, 400);
        if (Navigation.loaderTimer) clearTimeout(Navigation.loaderTimer);
        Navigation.loaderTimer = setTimeout(function(){
            $('#content').addClass('loading');
        }, 400);
    },
    initContent: function(event, content) {
        content = $(content);
        content.find('a[href]').on('click', Navigation.onClickLink);
        content.find('a[href][data-marker]').on('mouseenter', Navigation.onMouseEnter);
        content.find('a[href][data-marker]').on('mouseleave', Navigation.onMouseLeave);
        content.find('a.start-tour,button.start-tour').on('click', event => {
            Navigation.setTourWaypoint(1)
        })
    },
    update: function () {
        if (Navigation.current().searchTerm !== false) {
            Application.searchInput.removeClass('changed').val(Navigation.current().searchTerm);
        }
    },
    isHome: function () {
        return Navigation.current().home;
    },
    setTourWaypoint: function (index) {
        if (WeleerMap.activeTourIndex && WeleerMap.activeTourIndex === index) return;

        if (index > 0 && index < WeleerMap.activeTourIndex) {
            let currentIndex = Navigation.currentIndex;
            while (currentIndex-- > 0 && Navigation.stack[currentIndex].tour && Navigation.stack[currentIndex].tour.id === WeleerMap.activeTour.id) {
                if (Navigation.stack[currentIndex].tour_index === index) {
                    window.history.go(currentIndex - Navigation.currentIndex);
                    return;
                }
            }
        }

        WeleerMap.setTourWaypoint(index);
        if (index > 0) {
            const waypoint = WeleerMap.activeTour.waypoints[index - 1];
            let state = {
                url: waypoint.url,
                title: waypoint.name,
                tour: WeleerMap.activeTour,
                noBack: true
            };
            Navigation.push(state);

            let distance = 0;
            for (let i = index; i < WeleerMap.activeTour.waypoints.length; i++) {
                distance += WeleerMap.activeTour.waypoints[i].distance || 0;
            }
            let distanceStr = Math.round(distance) + ' m';
            if (distance > 1000) {
                distance = Math.round(distance / 100) / 10;
                if (distance % 1 <= 0.1 || distance % 1 >= 0.9) distance = Math.round(distance);
                distanceStr = distance.toFixed().trim(0).trim('.').replace('.', '.') + ' km';
            } else if (distance > 100) {
                distance = Math.round(distance / 100) * 100;
                distanceStr = distance + ' m';
            }
            if (distance == 0) $('#tour-progress .progress').text('');
            else $('#tour-progress .progress').text('Nog ' + distanceStr);

            if (index > 1) $('#tour-controls button.prev').removeAttr('disabled');
            else $('#tour-controls button.prev').attr('disabled', 'disabled');

            if (index < WeleerMap.activeTour.waypoints.length) $('#tour-controls button.next').text('Volgende');
            else $('#tour-controls button.next').text('Beëindigen');
        }
    },
    prevWaypoint: function () {
        if (WeleerMap.activeTour && WeleerMap.activeTourIndex > 1) {
            Navigation.setTourWaypoint(WeleerMap.activeTourIndex - 1);
        }
    },
    nextWaypoint: function () {
        if (WeleerMap.activeTour && WeleerMap.activeTourIndex < WeleerMap.activeTour.waypoints.length) {
            Navigation.setTourWaypoint(WeleerMap.activeTourIndex + 1);
        } else {
            Navigation.goBackToHome()
        }
    },
    parsePolygon: function (polygon) {
        if (typeof polygon === 'string') polygon = JSON.parse(polygon);
        if (!polygon[0]) return polygon;
        if (typeof polygon[0] === 'number' && typeof polygon[1] === 'number') {
            return { lat: polygon[0], lng: polygon[1] };
        } else {
            for (var i = 0; i < polygon.length; i++) {
                polygon[i] = Navigation.parsePolygon(polygon[i]);
            }
            return polygon;
        }
    },
    onClickLink: function(event) {
        let link = $(this);
        if (link.attr('target') || link.hasClass('link')) return;
        event.preventDefault();
        event.stopPropagation();
        let state = {
            url: link.attr('href'),
            searchTerm: link.data('search-term'),
            title: link.attr('title') || link.data('title'),
            back: link.data('back'),
            marker: link.data('marker'),
            cluster: link.data('cluster')
        };
        if (Navigation.current().markers) {
            if (!state.marker || $.inArray(state.marker, Navigation.current().markers) > -1) {
                state.markers = Navigation.current().markers;
            } else if (!state.cluster) {
                if (link.data('optional-cluster')) state.cluster = link.data('optional-cluster');
            } else {
                state.cluster = 1;
            }
        } else if (!state.cluster) state.cluster = link.data('optional-cluster')
        Navigation.push(state);
    },
    onClickBack: function() {
        window.history.back();
    },
    onPopState: function(event) {
        if (event.state) {
            if (!event.state.session || event.state.session != Navigation.session) window.location.reload();
            else Navigation.goToIndex(event.state.index);
        } else Navigation.goToIndex(0);
    },
    onMouseEnter: function() {
        if (WeleerMap.initialized) WeleerMap.hoverMarker($(this).data('marker'));
    },
    onMouseLeave: function() {
        if (WeleerMap.initialized) WeleerMap.unHoverMarker($(this).data('marker'));
    }
};
